module.exports = __webpack_public_path__ + "static/img/bg_6.6fbac37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_6.jpg
// module id = aAqf
// module chunks = 1